export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Puma Energy Foundation Annual Report 2025",
  "shortTitle": "",
  "description": "",
  "width": 686,
  "height": 894,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/2025",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "https://pumaenergyfoundation.touchline.org/2025/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/2025/static/_content/puma-energy-foundation-annual-report-2025.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true,
  },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC 1-logo" style="top:5px;left:-18px;" src="/2025/static/_content/1-logo-1.png"/>
      <img class="abs halfScale 1-title" style="top:660px;left:188px;" src="/2025/static/_content/1-title-1.png"/>
      <img class="abs halfScale 1-title" style="top:716px;left:172px;" src="/2025/static/_content/1-title-2.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(cOf("1-logo"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)
          .staggerFromTo(cOf("1-title"), 0.8, {opacity:0, x: -50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.2);
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "ANNUAL REPORT  2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 3-title" style="top:487px;left:80px;" src="/2025/static/_content/3-title-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(04);" style="top:542px; left:113px; width:180px; height:25px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(06);" style="top:580px; left:113px; width:180px; height:25px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(08);" style="top:622px; left:113px; width:180px; height:72px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:542px; left:410px; width:180px; height:60px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:618px; left:410px; width:180px; height:50px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(28);" style="top:680px; left:410px; width:180px; height:25px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:728px; left:410px; width:180px; height:25px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.fromTo(cOf("3-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);

          setTimeout(function() {
          addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg3Anim.stop();          
          removeContentLinks();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  03  ANNUAL REPORT 2025  CONTENTS 4 6 8   OPENING STATEMENT  18   ROAD SAFETY Amend Transaid World Bicycle Relief  OUR PARTNERS  CLEAN ENERGY Barefoot College Latin America Solar Sister We Care Solar Young Africa  26   OTHER PARTNERS APROQUEN CONEXION  28 30  STAFF ENGAGEMENT  CONTACT & PHOTO CREDITS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 4-title" style="top:141px;left:65px;" src="/2025/static/_content/4-title-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.fromTo(cOf("4-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);
        }

        function onPageLeave() {
          pg4Anim.stop();
        }
      `,
      "searchText": "04  CHAIRMAN’S FOREWORD  I am pleased to present the Puma Energy Foundation Annual Report 2025, highlighting our strategy to advance road safety and expand clean energy access for households and remote health facilities. In rural healthcare systems, distance and power are some of the most persistent constraints. In Zambia, bicycles were distributed to community-based health workers across three provinces in coordination with the Ministry of Health, enabling outreach to approximately 25,300 households who would otherwise be reached on foot. In Malawi, unreliable electricity in maternity wards increases risk during deliveries. Through the Light Every Birth programme implemented by We Care Solar, 475 Solar Suitcases were installed in 434 health facilities, covering 86% of maternal health centres nationwide and supporting approximately 34,000 births each month with reliable lighting during grid outages. As one mother delivering during a power failure put it simply: “The main electricity was off, but the solar power was there.” MCEBISI JONAS CHAIR OF THE FOUNDATION BOARD  These interventions are deliberately simple, resilient and scalable. They function independently of fragile infrastructure and deliver results under stress – precisely the characteristics we seek when deploying capital. They are community centred and fulfil our vision of energising communities across Africa and Latin America. We are grateful for Puma Energy’s USD 1 million annual support, which enables disciplined investment, strong governance and accountability to the business that funds this work. Mcebisi Jonas"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScale 5-title" style="top:141px;left:79px;" src="/2025/static/_content/5-title-1.png"/>
      <img class="abs halfScale 5-quote" style="top:580px;left:452px;" src="/2025/static/_content/5-line-1.png"/>
      <img class="abs halfScale 5-quote" style="top:579px;left:466px;" src="/2025/static/_content/5-quote-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.fromTo(cOf("5-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          pg5Anim.staggerFromTo(cOf("5-quote"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.3);
        }

        function onPageLeave() {
          pg5Anim.stop();
          resetNumbers("6-no");
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  05  ANNUAL REPORT 2025  EXECUTIVE DIRECTOR’S FOREWORD 2025 was a year defined by execution and measurable results. Across all our programmes, the Foundation focused on converting funding into outcomes, aligning delivery with real demand, market forces and public systems. As our 2024-2028 strategy came fully into fruition in its second year, our partners' work reached over 116,000 people, ten times more than in 2024, with practical solutions across energy access, healthcare delivery and road safety. Our road safety portfolio addressed a material and persistent risk. In Ghana, where commercial transport crashes remain a leading cause of death and economic loss. In Malawi and Zambia, a motorcycle taxi rider training programme is underway, targeting 900 riders in its first phase and establishing consistent standards in a sector that has historically lacked formal training. As one driver noted after training, “Before the training, we didn’t realise how small changes in driving behaviour could prevent serious accidents.” In Latin America, the Foundation maintained a small, focused portfolio across employment, energy access and prevention. In El Salvador, where youth unemployment remains a structural constraint, we concluded our partnership with Conexión El Salvador, delivering digital bootcamps that trained 246 young people, with 153 moving into employment in the technology sector. In Guatemala, the Foundation advanced rural solar programmes through site assessments and delivery planning for off-grid household electrification. In Nicaragua, we continued supporting APROQUEN, focusing on burn prevention through community education. Behind these numbers are fewer preventable accidents, functioning energy services and livelihoods tied to real demand. I thank our Board, Puma Energy and our partners for their continued focus on execution, accountability and results. Dario Soto Abril  DARIO SOTO ABRIL EXECUTIVE DIRECTOR  Our work reached over 116,000 people, ten times more than in 2024."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 6-title" style="top:140px;left:62px;" src="/2025/static/_content/6-title-1.png"/>
      <img class="abs halfScaleC 6-icon" style="top:682px;left:48px;" src="/2025/static/_content/6-icon-1.png"/>
      <img class="abs halfScaleC 6-icon" style="top:682px;left:226px;" src="/2025/static/_content/6-icon-2.png"/>
      <img class="abs halfScaleC 6-icon" style="top:674px;left:333px;" src="/2025/static/_content/6-icon-3.png"/>

      <h1 id="6-no" class="abs gothamBold 6-no" style="top:724px;left:64px; font-size: 1.4em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 116334, "comma": true}' ></h1>
      <h1 id="6-no" class="abs gothamBold 6-no" style="top:724px;left:249px; font-size: 1.4em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 9}' ></h1>

      <img class="abs halfScale 6-number" style="top:729px;left:349px;" src="/2025/static/_content/6-num-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.fromTo(cOf("6-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("6-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.4, 1.4)
          .fromTo(cOf("6-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("6-no")[0])}}, 1.6)
          .fromTo(cOf("6-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("6-no")[1])}}, 1.8)
          .fromTo(cOf("6-number"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2);
        }

        function onPageLeave() {
          resetNumbers("6-no");
          pg6Anim.stop();
        }
      `,
      "searchText": "06  OUR PARTNERS In 2025, Puma Energy Foundation supported nine partners across eight countries in Africa and Latin America.  BAREFOOT COLLEGE LATIN AMERICA Guatemala  CONEXION El Salvador  APROQUEN Nicaragua  2025 IN NUMBERS 116,334  PEOPLE BENEFITING FROM OUR PARTNERS' PROGRAMMES  9  PARTNERS SUPPORTED  USD 1 MILLION  ANNUAL BUDGET  SINCE ITS INCEPTION IN 2013, THE FOUNDATION HAS INVESTED USD 12.8 MILLION IN PHILANTHROPIC PROGRAMMING."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  07  ANNUAL REPORT 2025  SOLAR SISTER Tanzania WE CARE SOLAR Malawi and Tanzania  AMEND – NEW Malawi and Zambia YOUNG AFRICA Mozambique  WORLD BICYCLE RELIEF Zambia  TRANSAID Ghana  KEY ‘ACCESS TO CLEAN ENERGY’ PARTNERS  ‘ROAD SAFETY’ PARTNERS  OTHER PARTNERS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 8-box" style="top:-290px;left:-135px;" src="/2025/static/_content/8-green-box-1.png"/>
      
      <img class="abs halfScaleC 8-title" style="top:2px;left:-171px;" src="/2025/static/_content/8-title-1.png"/>

      <img class="abs halfScaleC 8-text" style="top:296px;left:-74px;" src="/2025/static/_content/8-text-1.png"/>
      <img class="abs halfScaleC 8-text" style="top:399px;left:-59px;" src="/2025/static/_content/8-text-2.png"/>
      <img class="abs halfScaleC 8-text" style="top:567px;left:-53px;" src="/2025/static/_content/8-text-3.png"/>
      <img class="abs halfScaleC 8-text" style="top:690px;left:-44px;" src="/2025/static/_content/8-text-4.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(cOf("8-box"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("8-title"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.1)
          .staggerFromTo(cOf("8-text"), 0.7, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.4)
        }

        function onPageLeave() {
          pg8Anim.stop();
        }
      `,
      "searchText": "08  CLEAN ENERGY WE PARTNER with organisations that provide clean and reliable energy to rural, last-mile households and medical facilities in low- and middle-income countries in Africa and Latin America. This two-fold approach emphasises health, sustainability and community empowerment. Without energy, communities cannot tackle issues like poverty, education and public health, which is why the Foundation invests in clean energy to address these challenges. For remote health facilities, solutions such as solar powered lighting systems and medical equipment dramatically improve patient care and treatment outcomes. We work with partners that empower women, entrepreneurs and young people, not only to provide access to energy, but also to strengthen local capacity and create sustainable livelihood opportunities. The work with our partners is described on the following pages."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC 9-icon" style="top:29px;left:503px;" src="/2025/static/_content/9-icon-1.png"/>
      <img class="abs halfScaleC 9-text" style="top:116px;left:445px;" src="/2025/static/_content/9-subtitle-1.png"/>
      <img class="abs halfScaleC 9-text" style="top:149px;left:401px;" src="/2025/static/_content/9-text-1.png"/>
      <img class="abs halfScaleC 9-text" style="top:266px;left:387px;" src="/2025/static/_content/9-text-2.png"/>
      <img class="abs halfScaleC 9-text" style="top:311px;left:382px;" src="/2025/static/_content/9-text-3.png"/>

      <img class="abs halfScaleC 9-icon" style="top:402px;left:502px;" src="/2025/static/_content/9-icon-2.png"/>
      <img class="abs halfScaleC 9-text" style="top:489px;left:380px;" src="/2025/static/_content/9-subtitle-2.png"/>
      <img class="abs halfScaleC 9-text" style="top:529px;left:372px;" src="/2025/static/_content/9-text-4.png"/>
      <img class="abs halfScaleC 9-text" style="top:620px;left:371px;" src="/2025/static/_content/9-text-5.png"/>
      <img class="abs halfScaleC 9-text" style="top:690px;left:399px;" src="/2025/static/_content/9-text-6.png"/>
      <img class="abs halfScaleC 9-text" style="top:772px;left:380px;" src="/2025/static/_content/9-text-7.png"/>
      <img class="abs halfScaleC 9-text" style="top:833px;left:351px;" src="/2025/static/_content/9-text-8.png"/>

      <div class="addContentLink" style="top:845px;left:457px;width:215px;height:10px">
        <a href="https://www.un.org/sustainabledevelopment/energy/" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:856px;left:457px;width:214px;height:20px">
        <a href="https://www.who.int/news-room/fact-sheets/detail/electricity-in-health-care-facilities/" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.staggerFromTo(cOf("9-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.8, 1)
          .staggerFromTo(cOf("9-text"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2);

          setTimeout(function(){
            addContentLinks();
          },3000)
        }

        function onPageLeave() {
          pg9Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  09  ANNUAL REPORT 2025  GLOBAL CHALLENGES ~8%  of the world’s population, primarily in least developed countries and sub-Saharan Africa, remain without access to electricity*  ~645 million  people are projected to still lack access to electricity by 2030*  ~1 billion  people in low- and lower-middleincome countries depend on health-care facilities that lack access to reliable electricity**  OUR PARTNERSHIPS’ 2025 IMPACT 14,783  people supplied with clean energy products. These include household appliances, solar home kits and clean cookstoves  269  people trained as solar technicians, electricians and entrepreneurs, of which 84% are women  80  health facilities in Malawi and Tanzania equipped with clean energy solutions  78,000  patients served across supported health facilities * https://www.un.org/sustainabledevelopment/energy/ ** https://www.who.int/news-room/fact-sheets/detail/ electricity-in-health-care-facilities"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 10-title" style="top:109px;left:-99px;" src="/2025/static/_content/10-title-1.png"/>
      <img class="abs halfScale 10-quote" style="top:683px;left:50px;" src="/2025/static/_content/10-line-1.png"/>
      <img class="abs halfScale 10-quote" style="top:635px;left:63px;" src="/2025/static/_content/10-quote-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.fromTo(cOf("10-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          pg10Anim.staggerFromTo(cOf("10-quote"), 0.8, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.3);
        }

        function onPageLeave() {
          pg10Anim.stop();
        }
      `,
      "searchText": "10  LIGHTING UP RURAL COMMUNITIES BAREFOOT COLLEGE LATIN AMERICA GUATEMALA  In rural Guatemala, about 370,000 households, including many in indigenous communities, still live without access to basic services such as electricity. In a country with the largest gender employment gap in Latin America, these communities also have high rates of illiteracy and poverty. By training rural women as solar engineers, entrepreneurs and educators, Barefoot College offers a brighter future. As well as providing women with skills, confidence and income, its programme enables clean energy to replace harmful, expensive and unsustainable sources. Being able to safely and affordably light their homes with solar power also benefits the whole community, allowing more time for income-generating, personal or educational activities before sunrise and after sunset. In 2025, Barefoot College held a second training cohort, as part of our partnership, with 12 students graduating. In addition to technical training components, students completed learning modules designed to boost financial literacy, leadership, entrepreneurship and digital technology skills. For the first time, two previous graduates, Carolina and Griselda, were invited to work as trainers for the 2025 cohort. These women were chosen in recognition of their commitment, hard work and ability to communicate with their peers. Female solar entrepreneurs from Belize also visited the group to share their experiences and participate in workshops.  I never saw myself as a leader. I was shy and unsure of how to speak up. But through the training, I learned about women’s rights and the importance of our voices. Now I feel more confident to participate, share what I’ve learned and support other women.” Margarita Brito, Barefoot College graduate and entrepreneur  THE WOMEN OF SANTA CLARA SOLAR ENTREPRENEURS  In the remote village of Santa Clara, four young women demonstrated the impact of their solar and life skills training through their entrepreneurial spirit and newfound leadership skills. After completing their training, the graduates returned to their community equipped not only with more technical knowledge, but the self-confidence to advocate for themselves. The women presented a proposal to community members and leaders that, in addition to the stipend provided by the programme for each installation, they should also receive a payment in recognition of their specialised service. While some community members were initially hesitant, the four women explained the value of their work and the importance of compensating their technical expertise. As a result, each of the four women earned an extra USD 250. This illustrates a broader success: recognising women as skilled professionals and community leaders, setting a precedent for sustainable, community-driven empowerment."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      <div class="abs" style="top:653px;left:93px;">
        <h1 id="11-no" class="abs gothamBook 11-no" style="font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 350}' ></h1>
      </div>
      <h1 id="11-no" class="abs gothamBook 11-no" style="top:653px;left:236px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 1900, "comma": true}' ></h1>
      <h1 id="11-no" class="abs gothamBook 11-no" style="top:730px;left:236px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 450, "append": "+"}' ></h1>
      <h1 id="11-no" class="abs gothamBook 11-no" style="top:653px;left:491px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 10}' ></h1>
      <h1 id="11-no" class="abs gothamBook 11-no" style="top:730px;left:492px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 3500, "comma" : true }' ></h1>

      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.fromTo(cOf("11-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no")[0])}}, 1)
          .fromTo(cOf("11-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no")[1])}}, 1.1)
          .fromTo(cOf("11-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no")[2])}}, 1.2)
          .fromTo(cOf("11-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no")[3])}}, 1.3)
          .fromTo(cOf("11-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no")[4])}}, 1.4);
        }

        function onPageLeave() {
          resetNumbers("11-no");
          pg11Anim.stop();
        }
      `,
      "searchText": "EXPECTED RESULTS BY MID-2027  350  1,900  USD 10  home lighting systems installed and maintained by graduates in 7 communities  community members now have direct access to sustainable electricity  per month savings per household in communities where income is roughly USD 350/month  450+  USD 3,500  additional hours of light per year for household, educational and livelihood activities  in monthly savings across 7 communities (13 communities in total over the full duration of the project)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 12-title" style="top:110px;left:-151px;" src="/2025/static/_content/12-title-1.png"/>
      <img class="abs halfScale 12-quote" style="top:658px;left:51px;" src="/2025/static/_content/12-line-1.png"/>
      <img class="abs halfScale 12-quote" style="top:611px;left:63px;" src="/2025/static/_content/12-quote-1.png"/>

      <h1 id="12-no" class="abs gothamBook 12-no" style="top:373px;left:445px; font-size: 1.56em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 162}' ></h1>
      <h1 id="12-no" class="abs gothamBook 12-no" style="top:410px;left:445px; font-size: 1.53em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 11908, "comma" : true }' ></h1>
      <h1 id="12-no" class="abs gothamBook 12-no" style="top:527px;left:445px; font-size: 1.54em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 500 }' ></h1>
      <h1 id="12-no" class="abs gothamBook 12-no" style="top:593px;left:445px; font-size: 1.53em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 85000, "comma" : true }' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("12-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("12-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[0])}}, 1.2)
          .fromTo(cOf("12-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[1])}}, 1.2)
          .fromTo(cOf("12-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[2])}}, 1.2)
          .fromTo(cOf("12-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[3])}}, 1.2)
          .staggerFromTo(cOf("12-quote"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 2.2);
        }

        function onPageLeave() {
          resetNumbers("12-no");
          pg12Anim.stop();
        }

      `,
      "searchText": "12  EMPOWERING WOMEN TO TACKLE ENERGY POVERTY SOLAR SISTER TANZANIA  For over 15 years, Solar Sister has empowered women in sub-Saharan Africa to create businesses and provide clean energy for their communities, helping to reduce energy poverty. In total, Solar Sister has helped 12,400 women entrepreneurs, who have collectively reached over 5.6 million people with clean energy solutions. In Tanzania alone, 5,223 women entrepreneurs trained by Solar Sister have provided 2.8 million people with access to clean energy. Our partnership has been key in driving the project’s growth into last-mile Tanzanian communities. It provides business training, mentorship, financing and networking opportunities for women entrepreneurs, who then bring their communities access to life-changing solar products. These include household appliances and clean cookstoves. In 2025, the first phase of our partnership concluded, helping Solar Sister to further develop its advanced Business Booster training programme. With Puma Energy Foundation funding over the next two years, Solar Sister Tanzania aims to reach 500 new entrepreneurs in three new regions, collectively bringing clean energy solutions to 85,000 people.  PARTNERSHIP ACHIEVEMENTS IN 2025  162 11,908  entrepreneurs supported  solar products sold by entrepreneurs  EXPECTED RESULTS BY 2028 Recruit and train  500  more entrepreneurs  Bring clean energy solutions to  85,000 This opportunity helped me open up mentally and see that opportunities are always there; we have to wake up and see them. My confidence has increased so much. I feel very good about being part of Solar Sister because it has taken me so far. I didn’t know if I could achieve the life I have right now.” Malitha Lawi, Solar Sister entrepreneur  people"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  EDITHA MASONGERA SOLAR SISTER ENTREPRENEUR  After her grandparents’ house burned down due to a candle fire, Editha was inspired to help bring clean, affordable light to her community. Having worked for 30 years tailoring and tending her small agricultural plot, Editha bought a Solar Sister lamp in 2017. As her business and confidence grew, she joined the Business Booster scheme. Now, she owns her home that she built with the proceeds from her business. Editha's dream is to continue growing her solar business and to open a clothes shop.  ANNUAL REPORT 2025  13"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 14-title" style="top:109px;left:-114px;" src="/2025/static/_content/14-title-1.png"/>
      <img class="abs halfScale 14-quote" style="top:347px;left:52px;" src="/2025/static/_content/14-line-1.png"/>
      <img class="abs halfScale 14-quote" style="top:299px;left:63px;" src="/2025/static/_content/14-quote-1.png"/>

      <h1 id="14-no" class="abs gothamBook 14-no" style="top:438px;left:444px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 80}' ></h1>
      <h1 id="14-no" class="abs gothamBook 14-no" style="top:482px;left:444px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 7}' ></h1>
      <h1 id="14-no" class="abs gothamBook 14-no" style="top:575px;left:444px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 78195, "comma" : true}' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim.staggerFromTo(cOf("14-title"), 0.8, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.4, 1)
          .staggerFromTo(cOf("14-quote"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.3)
          .fromTo(cOf("14-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("14-no")[0])}}, 1.8)
          .fromTo(cOf("14-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("14-no")[1])}}, 1.9)
          .fromTo(cOf("14-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("14-no")[2])}}, 2);
        }

        function onPageLeave() {
          resetNumbers("14-no");
          pg14Anim.stop();
        }
      `,
      "searchText": "14  BRIGHTER AND SAFER MATERNITY CARE WE CARE SOLAR  MALAWI AND TANZANIA  I did not feel great giving birth to my first child because it was dark. Today I gave birth safely and there was a lot of light. The difference is that right now we have made a step ahead. Even if the main electricity goes off, the solar power is there all the time. Afternoon, morning or evening, the power is there.” Elizabeth Malima, mother from Mgusu  An estimated 59% of health facilities in low- and middle-income countries lack reliable electricity or have no electricity at all. This causes serious challenges for health workers, ranging from turning patients away to working in the dark which can lead to serious complications. We Care Solar’s Light Every Birth initiative targets countries with high rates of maternal mortality. Providing electricity to remote health centres can decrease maternal deaths by 50% and infant deaths by 63%. We Care Solar’s Solar Suitcase® is a practical and cost-effective solution. The system, comprised of solar panels, a 12V battery, medical lights and medical devices, is easy to fit and maintain. In 2025, our funding helped We Care Solar to distribute and install 30 Solar Suitcases in Tanzania and 50 in Malawi. A total of 274 health staff were trained to use the Solar Suitcases and 39 local technicians were certified to maintain them, 18 of whom are women. This will enable an estimated 96,000 mothers and newborns to benefit from safer healthcare every year. Thanks to the inclusion of rechargeable headlamps and specialised obstetric instruments in the Solar Suitcases, surveys show that both staff and mothers feel more confident in the quality of care provided.  PARTNERSHIP ACHIEVEMENTS IN 2025 In Tanzania and Malawi  80  health care facilities  with an additional  7  funded by a Puma Energy staff fundraiser, equipped with Solar Suitcases  78,195 mothers and newborns benefited from improved healthcare services in 2025 alone"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  15  ANNUAL REPORT 2025  CERVICAL CANCER SCREENING Malawi has the highest rates of cervical cancer incidence and mortality worldwide, meaning early detection is key to prevention. Because sufficient lighting is required to accurately detect precancerous lesions, health workers have utilised rechargeable headlamps included in the Solar Suitcases to conduct screenings safely and effectively. “Most facilities do not have Angle Poise lamps that are used at these clinics. At Benga Health Centre, Yankho Nsaiwa uses headlamps to screen clients for Cervical cancer. For mobile clinics, the headlamps are handy to use during cervical cancer screening.” Eunice Mwandira, We Care Solar, Malawi Country Program Manager"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 16-title" style="top:109px;left:-203px;" src="/2025/static/_content/16-title-1.png"/>
      <img class="abs halfScale 16-quote" style="top:657px;left:52px;" src="/2025/static/_content/16-line-1.png"/>
      <img class="abs halfScale 16-quote" style="top:609px;left:63px;" src="/2025/static/_content/16-quote-1.png"/>

      <div class="addContentLink" style="top:794px;left:194px;width:208px;height:12px">
        <a href="https://iea.blob.core.windows.net/assets/7829e75d-980a-40da-99b1-f8953a510ba4/Mozambique2024.pdf" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:803px;left:63px;width:176px;height:12px">
        <a href="https://iea.blob.core.windows.net/assets/7829e75d-980a-40da-99b1-f8953a510ba4/Mozambique2024.pdf" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim.fromTo(cOf("16-title"), 0.8, {opacity:0, x: 35}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("16-quote"), 0.8, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.3);

           setTimeout(function(){
            addContentLinks();
          },3000)
        }

        function onPageLeave() {
          pg16Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "16  GREEN SKILLS AND SUSTAINABLE CAREERS FOR YOUNG PEOPLE YOUNG AFRICA MOZAMBIQUE  Mozambique has one of the youngest populations in Africa, but its young people lack access to education, training and sustainable employment. The situation is particularly difficult in Northern Mozambique’s Cabo Delgado region, where conflict and insecurity are inhibiting economic opportunities. Moreover, only 9% of the population living in rural areas have access to energy.1 To help address this challenge, we have supported the Sustainable Youth Empowerment project in the northern province of Cabo Delgado for the last two years. The project equips young people with solar technology skills and supports them to build their own renewable energy businesses. Despite serious constraints from insecurity and political unrest in the region, the project surpassed its targets for both the number of young people supported and the percentage of graduates working at the end of the project: start-up kits were distributed to support 72 graduates in launching their small businesses, and 20 small business groups were formed to install 160 solar home systems in their communities. By project end, over 78% were employed or running their own business. In addition to 146 young people successfully graduating over the past two years, the project has engaged more than 4,000 local people in a renewable energy awareness campaign.  I don't live a luxurious life, but we no longer go hungry. I can support my mother and am proud to share part of my income. I face life with optimism and have regained my self-esteem. This opportunity changed my life.” Mazuva Constantino, Young Africa graduate 1 World Bank Group https://data.worldbank.org/indicator/EG.ELC.ACCS.RU.ZS?locations=MZ"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      
      <h1 id="17-no" class="abs gothamBook 17-no" style="top:318px;left:461px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 1973, "comma" : true}' ></h1>
      <h1 id="17-no" class="abs gothamBook 17-no" style="top:394px;left:461px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 50}' ></h1>
      <h1 id="17-no" class="abs gothamBook 17-no" style="top:570px;left:461px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 78.5, "decimals" : 1, "append" : "%"}' ></h1>
      <h1 id="17-no" class="abs gothamBook 17-no" style="top:680px;left:461px; font-size: 1.6em; font-weight: 300; color: #77aa4e; padding: 0px; margin: 0px;"  data-number='{"to": 20}' ></h1>

      <img class="abs halfScaleC 17-arrows" style="top:390px;left:457px;" src="/2025/static/_content/17-arrows-1.png"/>
      <img class="abs halfScaleC 17-text" style="top:474px;left:471px;" src="/2025/static/_content/17-text-1.png"/>
      <img class="abs halfScaleC 17-text" style="top:519px;left:466px;" src="/2025/static/_content/17-text-2.png"/>

      <img class="abs halfScale 17-barchart" style="top:603px;left:459px;" src="/2025/static/_content/17-bar-2.png"/>
      <img class="abs halfScale 17-bar" style="top:603px;left:459px;" src="/2025/static/_content/17-bar-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim.fromTo(cOf("17-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[0])}}, 1)
          .fromTo(cOf("17-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[1])}}, 1.2)
          .fromTo(cOf("17-arrows"), 0.6, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)
          .staggerFromTo(cOf("17-text"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.8)
          .fromTo(cOf("17-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[2])}}, 2.2)
          .fromTo(cOf("17-bar"), 0.6, {scaleX: 0}, {scaleX:0.5, ease: Power2.easeOut}, 2.3)
          .fromTo(cOf("17-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[3])}}, 2.5);
        }

        function onPageLeave() {
          resetNumbers("17-no");
          pg17Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  17  ANNUAL REPORT 2025  PARTNERSHIP ACHIEVEMENTS IN 2025  1,973 community members reached through renewable energy awareness campaigns  50  young people supported trained  25 males  25 females  78.5% of graduates economically active by project end  20  business groups formed with 160 solar home systems distributed to 40 graduates for reselling them to community members"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC 18-box" style="top:-206px;left:-135px;" src="/2025/static/_content/18-green-box-1.png"/>   
 
      <img class="abs halfScaleC 18-title" style="top:2px;left:-160px;" src="/2025/static/_content/18-title-1.png"/>

      <img class="abs halfScaleC 18-text" style="top:296px;left:-85px;" src="/2025/static/_content/18-text-1.png"/>
      <img class="abs halfScaleC 18-text" style="top:413px;left:-85px;" src="/2025/static/_content/18-text-2.png"/>
      <img class="abs halfScaleC 18-text" style="top:560px;left:-42px;" src="/2025/static/_content/18-text-3.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim.fromTo(cOf("18-box"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("18-title"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.1)
          .staggerFromTo(cOf("18-text"), 0.7, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.4)
        }

        function onPageLeave() {
          pg18Anim.stop();
        }
      `,
      "searchText": "18  ROAD SAFETY OUR PARTNER organisations are dedicated to addressing critical road safety gaps across low- and middle-income countries in Africa. By focusing on vulnerable and last-mile communities, we combine local advocacy with practical, innovative solutions to reduce traffic accidents. These programmes address road safety and safe mobility by expanding healthcare access in rural Zambia, establishing motorcycle taxi rider safety training in Malawi and Zambia, and expanding truck driver safety training in Ghana. These solutions improve livelihoods while building a safer, more resilient future. The following pages showcase the work of our partners."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 19-icon" style="top:29px;left:503px;" src="/2025/static/_content/19-icon-1.png"/>
      <img class="abs halfScaleC 19-text" style="top:110px;left:447px;" src="/2025/static/_content/19-subtitle-1.png"/>
      <img class="abs halfScaleC 19-text" style="top:160px;left:440px;" src="/2025/static/_content/19-text-1.png"/>
      <img class="abs halfScaleC 19-text" style="top:217px;left:472px;" src="/2025/static/_content/19-text-2.png"/>
      <img class="abs halfScaleC 19-text" style="top:278px;left:417px;" src="/2025/static/_content/19-text-3.png"/>
      <img class="abs halfScaleC 19-text" style="top:338px;left:406px;" src="/2025/static/_content/19-text-4.png"/>
      <img class="abs halfScaleC 19-icon" style="top:393px;left:503px;" src="/2025/static/_content/19-icon-2.png"/>
      <img class="abs halfScaleC 19-text" style="top:486px;left:381px;" src="/2025/static/_content/19-subtitle-2.png"/>
      <img class="abs halfScaleC 19-text" style="top:542px;left:407px;" src="/2025/static/_content/19-text-5.png"/>
      <img class="abs halfScaleC 19-text" style="top:583px;left:432px;" src="/2025/static/_content/19-text-6.png"/>
      <img class="abs halfScaleC 19-text" style="top:637px;left:388px;" src="/2025/static/_content/19-text-7.png"/>
      <img class="abs halfScaleC 19-text" style="top:833px;left:422px;" src="/2025/static/_content/19-text-8.png"/>
  
      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();
          pg19Anim.staggerFromTo(cOf("19-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.9, 1)
          .staggerFromTo(cOf("19-text"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2);
        }

        function onPageLeave() {
          pg19Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  19  ANNUAL REPORT 2025  GLOBAL CHALLENGES 1.3  million deaths annually from traffic accidents  10th  leading cause of death worldwide  #1  cause of death for children and youth aged 5-29 years  90%  of fatal accidents in low- and middle-income countries*  OUR PARTNERSHIPS’ 2025 IMPACT 6,625  people trained in road safety  8  new road safety training courses developed  259  bikes distributed to community health workers to reach patients faster and more efficiently  * All statistics from the World Health Organization’s Global Plan – Decade of Action for Road Safety 2021-2030"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC 20-title" style="top:653px;left:-188px;" src="/2025/static/_content/20-title-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim.fromTo(cOf("20-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg20Anim.stop();
        }
      `,
      "searchText": "20  PRACTICAL SKILLS TRAINING FOR MOTORCYCLE TAXI RIDERS AMEND  MALAWI AND ZAMBIA"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      
      <h1 id="21-no" class="abs gothamBook 21-no" style="top:747px;left:85px; font-size: 1.62em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 900 }' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim.fromTo(cOf("21-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[0])}}, 1);
        }

        function onPageLeave() {
          resetNumbers("21-no");
          pg21Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  21  Over the past 20 years, motorcycle usage has risen rapidly in sub-Saharan Africa. Motorcycles have many benefits, improving access in both cities and rural areas, and providing employment and business opportunities, with many being used as taxis and for deliveries. But they also bring significant safety concerns, with an estimated 100,000 riders and passengers killed every year on the road. In many African countries, the vast majority of motorcycle riders have received no formal training and have no driving licence.  EXPECTED RESULTS BY 2026 Around  900  motorcycle taxi riders to receive training in Malawi and Zambia  Malawi is currently facing an explosion in the number of moto-taxis (known locally as 'kabaza’). According to a 2024 study by the country’s Institute of Public Opinion and Research (Ipor), 72% of the population relies on moto-taxis despite these risks, primarily because they are the only affordable means of transport. This is despite accidents becoming 30% riskier in 2024. During early 2026, our partner, Amend, aims to train 400 motorcycle taxi riders in Malawi, also supporting these riders to obtain their licences. Amend’s training course focuses on practical life-saving skills and is designed specifically for the African context. Later in the year, Amend will train a further 500 motorcycle riders in Zambia."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "22"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 23-title" style="top:110px;left:-116px;" src="/2025/static/_content/23-title-1.png"/>
      <img class="abs halfScale 23-quote" style="top:670px;left:68px;" src="/2025/static/_content/23-line-1.png"/>
      <img class="abs halfScale 23-quote" style="top:624px;left:80px;" src="/2025/static/_content/23-quote-1.png"/>

      <h1 id="23-no" class="abs gothamBook 23-no" style="top:371px;left:460px; font-size: 1.6em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 6440, "comma" : true}' ></h1>

      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim.fromTo(cOf("23-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0])}}, 1.3)
          .staggerFromTo(cOf("23-quote"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 2)
        }

        function onPageLeave() {
          resetNumbers("23-no");
          pg23Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  23  ANNUAL REPORT 2025  ROAD SAFETY TRAINING FOR HGV DRIVERS TRANSAID GHANA  Major infrastructure projects in Ghana have raised the demand for use of heavy goods vehicles (HGVs). The nation recorded over 7,200 road crashes, resulting in 1,504 fatalities, in the first half of 2025 alone. The Foundation continues to partner with Transaid to support the roll out of the new national HGV driver training standard. The organisation worked with local transport associations, such as Ghana National Cargo Transporters’ Association, to introduce the HGV training standard and support building government capacity for the Driver and Vehicle Licensing Authority (DVLA) to assess and examine truck drivers.  PARTNERSHIP ACHIEVEMENTS IN 2025  6,440 HGV drivers sensitised in safe driving practices  Engagement and sensitisation sessions have so far reached 6,440 HGV drivers in person and 1,657 online. Building in-house training capacity in Kumasi by implementing Transaid’s ‘train the trainer’ approach has now been completed, with 16 trainers successfully completing the course using a newly developed refresher training manual, covering topics such as driving at night and vehicle checks. Transaid is also providing technical support to establish a training centre for new and existing HGV driver trainers, with two new master trainers having completed theory and practical training at the centre.  We have now learned that drivers have to take a break after every four hours of driving. Even a 10-minute rest can help. We also learned to not allow the pressure of the job to prevent us from putting up our warning triangles when our vehicles break down. This will go a long way to reduce the accidents on Ghana’s roads.” Chairman of the Nkrankwanta Cargo Branch in the Bono Region"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <img class="halfScale 24-title-1" style="top:141px; left:65px;" src="/2025/static/_content/24-title-1.png" />      
      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          pg24Anim.fromTo(cOf("24-title-1"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.2);
        }

        function onPageLeave() {
          pg24Anim.stop();
        }
      `,
      "searchText": "24  PROVIDING HEALTHCARE ACCESS TO RURAL COMMUNITIES WORLD BICYCLE RELIEF ZAMBIA  Rural communities face significant barriers to accessing healthcare, with distance being one of the biggest challenges. The Wheels for Health initiative from World Bicycle Relief is designed to address the critical need for Zambian health workers to have reliable transport. Our partnership provides durable Buffalo bicycles to community-based health workers, enabling them to cover larger distances, reach more patients and increase retention rates. Most community-based health workers are assigned to catchments of 100 households with approximately five people each, thereby reaching 500 individuals. Over time, the programme aims to reach 39,100 households and 195,500 rural residents."
     }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <h1 id="25-no-1" class="abs gothamBook 25-no" style="top:562px; left:90px; font-size: 1.56em; font-weight: 300; color: #007042; padding: 0px; margin: 0px;"  data-number='{"to": 38}'></h1>
        <h1 id="25-no-1" class="abs gothamBook 25-no" style="top:611px; left:91px; font-size: 1.55em; font-weight: 300; color: #007042; padding: 0px; margin: 0px;"  data-number='{"to": 110}'></h1>
        <h1 id="25-no-1" class="abs gothamBook 25-no" style="top:669px; left:91px; font-size: 1.56em; font-weight: 300; color: #007042; padding: 0px; margin: 0px;"  data-number='{"to": 6}'></h1>
        <h1 id="25-no-1" class="abs gothamBook 25-no" style="top:729px; left:91px; font-size: 1.54em; font-weight: 300; color: #007042; padding: 0px; margin: 0px;"  data-number='{"to": 259}'></h1>
        <h1 id="25-no-1" class="abs gothamBook 25-no" style="top:729px; left:204px; font-size: 1.56em; font-weight: 300; color: #007042; padding: 0px; margin: 0px;"  data-number='{"to": 27000, "comma": "true"}'></h1>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){animateNumber(cOf("25-no")[0]);}, 1300);
          setTimeout(function(){animateNumber(cOf("25-no")[1]);}, 1400);
          setTimeout(function(){animateNumber(cOf("25-no")[2]);}, 1500);
          setTimeout(function(){animateNumber(cOf("25-no")[3]);}, 1600);
          setTimeout(function(){animateNumber(cOf("25-no")[4]);}, 1700);
        }

        function onPageLeave() {
          resetNumbers("25-no");
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  ANNUAL REPORT 2025  MARGARET COMMUNITY HEALTH WORKER, ZAMBIA  Working in her community, Margaret serves as a Community Health Worker supporting pregnant women and sick patients across long rural distances. Before receiving a bicycle from World Bicycle Relief, Margaret walked to reach pregnant mothers who were delivering at home because transport to the health facility was too far, costly or unavailable. The bicycle transformed Margaret’s reach and reliability. She now transports mothers to the Kalindawalo Health Facility faster for a safe delivery, cutting travel time and attending community health meetings with the time saved. “Now I can reach mothers in time and carry other sick people in the community to the health facility who are faced with transport challenges.”  PARTNERSHIP ACHIEVEMENTS IN 2025  38  participating health facilities in the Mpongwe and Masaiti districts  110  health workers and health facility staff trained to participate and co-implement the Wheels for Health initiative locally  6  field mechanics trained and equipped to maintain bicycles for health service delivery  259  Buffalo bicycles distributed to health workers  27,000  households reached, representing 135,000 people  25"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <img class="halfScale 26-title-1" style="top:141px; left:158px;" src="/2025/static/_content/26-title-1.png" /> 
        <img class="halfScale 26-side-title-1" style="top:127px; left:37px;" src="/2025/static/_content/26-side-title-1.png" /> 

        <h1 id="26-no-1" class="abs gothamBook 26-no" style="top:371px; left:444px; font-size: 1.55em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 1724, "comma": "true"}' ></h1>
        <h1 id="26-no-2" class="abs gothamBook 26-no" style="top:432px; left:444px; font-size: 1.55em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 262}' ></h1>
        <h1 id="26-no-3" class="abs gothamBook 26-no" style="top:507px; left:444px; font-size: 1.55em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 27}' ></h1>
        <h1 id="26-no-3" class="abs gothamBook 26-no" style="top:559px; left:444px; font-size: 1.55em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 14}' ></h1>
        <h1 id="26-no-3" class="abs gothamBook 26-no" style="top:612px; left:444px; font-size: 1.55em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 19}' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim.fromTo(cOf("26-side-title-1"), 0.8, {opacity:0, y:40}, {opacity:1, y:0, ease: Power2.easeOut}, 1.0);
          pg26Anim.fromTo(cOf("26-title-1"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.2);

          setTimeout(function(){animateNumber(cOf("26-no")[0]);}, 1300);
          setTimeout(function(){animateNumber(cOf("26-no")[1]);}, 1400);
          setTimeout(function(){animateNumber(cOf("26-no")[2]);}, 1500);
          setTimeout(function(){animateNumber(cOf("26-no")[3]);}, 1600);
          setTimeout(function(){animateNumber(cOf("26-no")[4]);}, 1700);
        }

        function onPageLeave() {
          resetNumbers("26-no");
          pg26Anim.stop();
        }
      `,
      "searchText": "OTHER PARTNERS  26  BURN PREVENTION AWARENESS AND CARE APROQUEN, INC NICARAGUA  PARTNERSHIP ACHIEVEMENTS IN 2025  1,724  children received burn prevention education  262  adults trained in burn prevention  Accidental burns are the second most common cause of death in low- and middle-income countries across Latin America, mainly affecting children aged 1-9. Families living in poverty often lack access and resources to the specialised care required for burn treatment. Since 2017, the Puma Energy Foundation has supported APROQUEN’s burn prevention programme, strengthening awareness of burn risks and first aid practices. In 2025, APROQUEN reached 19 schools and provided 1,724 children with interactive, age-appropriate burn prevention education. Workshops were also conducted for parents, teachers and community leaders. As part of the programme, adult participants create and share burn prevention messages through social media, amplifying key educational content and extending its reach within their communities. APROQUEN is currently developing a regional capacitybuilding webinar to support sister organisations across Central America. In addition to ongoing technical assistance in Costa Rica, the organisation plans to expand support to Guatemala and Honduras in 2026, further strengthening burn prevention efforts throughout the region.  27  burn prevention workshops provided for children and  14 19  provided for adults  schools visited in the departments with the highest incidence of burns"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
        <img class="halfScale 27-title-1" style="top:141px; left:79px;" src="/2025/static/_content/27-title-1.png" /> 

        <h1 id="27-no-1" class="abs gothamBook 27-no" style="top:370px; left:461px; font-size: 1.7em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 11}' ></h1>
        <h1 id="27-no-2" class="abs gothamBook 27-no" style="top:437px; left:461px; font-size: 1.7em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 10}' ></h1>
        <h1 id="27-no-3" class="abs gothamBook 27-no" style="top:501px; left:461px; font-size: 1.7em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 39}' ></h1>
        <h1 id="27-no-4" class="abs gothamBook 27-no" style="top:501px; left:549px; font-size: 1.7em; font-weight: 300; color: #e99d6e; padding: 0px; margin: 0px;"  data-number='{"to": 62}' ></h1>
     
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim.fromTo(cOf("27-title-1"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.2);

          setTimeout(function(){animateNumber(cOf("27-no")[0]);}, 1300);
          setTimeout(function(){animateNumber(cOf("27-no")[1]);}, 1400);
          setTimeout(function(){animateNumber(cOf("27-no")[2]);}, 1500);
          setTimeout(function(){animateNumber(cOf("27-no")[3]);}, 1600);
        }

        function onPageLeave() {
          resetNumbers("27-no");
          pg27Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  27  ANNUAL REPORT 2025  DIGITAL SKILLS TRAINING FOR YOUNG PEOPLE CONEXION  EL SALVADOR In El Salvador, youth unemployment rates can be as high as 46%. The everevolving information technology (IT) and technology fields, however, present an opportunity. By providing IT training, CONEXION connects underserved young people with meaningful economic opportunities. In 2025, CONEXION further developed its bootcamp curriculum to meet market needs. This included user experience, user interface design, digital marketing using artificial intelligence (AI) and software development using AI. Our partnership with CONEXION ended in 2025, but we are proud of the results the organisation made in advancing digital literacy for young people.  PARTNERSHIP ACHIEVEMENTS IN 2025  11  teachers trained in English and technical language skills  10  members of staff certified in digital development tools  39  young people employed  62  young people trained"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
        <img class="halfScale 28-title-1" style="top:124px; left:62px;" src="/2025/static/_content/28-title-1.png" />     
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim.fromTo(cOf("28-title-1"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.0);
        }

        function onPageLeave() {
          pg28Anim.stop();
        }
      `,
      "searchText": "28  STAFF ENGAGEMENT PUMA ENERGY EMPLOYEES POWERING LOCAL CHANGE Across three continents, Puma Energy employees are pairing local insight with Foundation support to turn volunteer goodwill into measurable results. Each initiative reflects the same principles: employee leadership, trusted local organisations and practical, low-carbon solutions that deliver long-term benefits, advancing the Foundation’s mission every day.  HONDURAS – Helping children with renewable power In Honduras, high energy costs and unreliable electricity put strain on child-care organisations serving vulnerable families. In response to this challenge, local Puma Energy staff partnered with the Foundation to install a solar system in Tegucigalpa for Aldeas Infantiles SOS. The installation will provide 25 years of renewable power to 11 homes, reducing both operating costs and emissions. This will enable more resources to be directed towards child protection and programmes that strengthen families.  PAPUA NEW GUINEA Implementing solar water and energy In a country where nearly 85% of people live in rural areas without reliable electricity, communities in the Kakondo Protected Area are addressing critical gaps in lighting and energy access to improve safety and evening activities. The organisation chosen by the PNG team has completed a new Community Resource Centre and is now installing 35 solar street lights and solar systems for the centre and 30 nearby households, benefiting several thousand residents."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
        <img class="halfScaleC 29-image" style="top:535px; left:46px;" src="/2025/static/_content/29-image-1.png" />
        <img class="halfScale 29-quote" style="top:639px; left:67px;" src="/2025/static/_content/29-line-1.png" />
        <img class="halfScale 29-quote" style="top:641px; left:80px;" src="/2025/static/_content/29-quote-1.png" />
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim.fromTo(cOf("29-image"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.1)
          .staggerFromTo(cOf("29-quote"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.4);
        }

        function onPageLeave() {
          pg29Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  ANNUAL REPORT 2025  29  INDIA – Supporting girls’ early education Access to early childhood education remains limited in India, particularly for girls in low-income communities. In Mumbai’s Kurla district, a group of Puma Energy employees established the H.O.P.E. (Humans Of Puma Energy) committee to support a daycare centre for 25 girls aged 4-10. The centre focuses on hygiene, life skills and school readiness, improving the girls’ long-term prospects and helping many transition into formal education.  The most inspiring part of our social impact work is seeing our teams champion the causes they care about. Their initiatives bring our company’s values to life and demonstrate what’s possible when local leadership meets corporate support. We’re proud to back their efforts and create lasting change together.” Mark Russell, CEO, Puma Energy"
        }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      <div class="contentLink" style="top:542px;left:99px;width:57px;height:15px">
        <a href="https://amend.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:555px;left:124px;width:86px;height:15px">
        <a href="https://aproquenkids.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:568px;left:211px;width:81px;height:15px">
        <a href="https://barefootcollege-guatemala.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:581px;left:64px;width:68px;height:15px">
        <a href="https://barefootcollege-guatemala.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:594px;left:121px;width:58px;height:15px">
        <a href="https://conexion.sv" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:607px;left:119px;width:69px;height:15px">
        <a href="https://solarsister.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:620px;left:105px;width:62px;height:15px">
        <a href="https://transaid.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:633px;left:132px;width:78px;height:15px">
        <a href="https://wecaresolar.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:646px;left:158px;width:105px;height:15px">
        <a href="https://worldbicyclerelief.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="top:659px;left:127px;width:77px;height:15px">
        <a href="https://youngafrica.org" target="_blank"></a>
      </div>

      <div class="contentLink" style="top:711px;left:445px;width:45px;height:15px">
        <a href="https://touchline.com" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){addContentLinks();}, 1000);
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "OUR PARTNERS’ WEBSITES  PHOTO CREDITS  Amend, amend.org APROQUEN, aproquenkids.org Barefoot College Latin America, barefootcollegeguatemala.org CONEXION, conexion.sv Solar Sister, solarsister.org Transaid, transaid.org We Care Solar, wecaresolar.org World Bicycle Relief, worldbicyclerelief.org Young Africa, youngafrica.org  Young Africa (cover, inside cover, 17) Amend (3, 20-21) We Care Solar (4-5, 15 Barefoot College Latin America (11, 30-31) Solar Sister (13) Transaid (18-19, 22) World Bicycle Relief (24-25) APROQUEN (26) CONEXION (27) We would like to thank all those who provided photography for this report. Copy, editing, design: Touchline"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="top:581px; left:79px; width:132px; height:17px">
          <a href="https://pumaenergyfoundation.org/" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){addContentLinks();}, 1000);
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Women in rural Guatemala learning practical solar skills with our partner Barefoot College Latin America to expand energy access in remote communities.  Puma Energy Foundation 1, rue de Jargonnant 1207 Geneva, Switzerland pumaenergyfoundation.org"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }

      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
      }

      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }

      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }

      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js